export const THEMES = [
  { id: 'default', name: 'Institucional', description: 'Azul Abogados Quiroz', swatches: ['#0B2340', '#173F67', '#2D648E', '#D8A33B'] },
  { id: 'plum', name: 'Berenjena legal', description: 'Inspirado en el tono editorial de la referencia', swatches: ['#32103F', '#5C1E70', '#814393', '#FF7A59'] },
  { id: 'emerald', name: 'Esmeralda', description: 'Verde profundo y sobrio', swatches: ['#123B32', '#1D6B57', '#329477', '#D9A441'] },
  { id: 'teal', name: 'Teal ejecutivo', description: 'Azul petróleo contemporáneo', swatches: ['#073B4C', '#0E7490', '#159A9C', '#F1B84B'] },
  { id: 'burgundy', name: 'Burdeos clásico', description: 'Vino institucional con acento cálido', swatches: ['#461423', '#78263C', '#A74A5F', '#E0AA57'] },
  { id: 'sapphire', name: 'Zafiro', description: 'Azul intenso, preciso y corporativo', swatches: ['#13234E', '#294E9B', '#4C78D0', '#E4B85C'] },
  { id: 'amber', name: 'Ámbar oscuro', description: 'Tierra profunda con contraste editorial', swatches: ['#332313', '#67411C', '#9B6A2F', '#F0C56C'] },
  { id: 'graphite', name: 'Grafito', description: 'Gris azulado sobrio y contemporáneo', swatches: ['#1E293B', '#334155', '#52657B', '#7DD3FC'] },
  { id: 'olive', name: 'Oliva ejecutivo', description: 'Verde olivo refinado con acento arena', swatches: ['#2F3A24', '#52663A', '#748B52', '#E6C77A'] },
  { id: 'coral', name: 'Coral profesional', description: 'Terracota elegante con contraste claro', swatches: ['#4A2420', '#8B3F36', '#B76052', '#F2B36D'] },
  { id: 'lavender', name: 'Lavanda nocturna', description: 'Índigo suave con acento lila', swatches: ['#292444', '#4A4275', '#7065A7', '#D7B9FF'] },
];

export const DEFAULT_THEME = 'default';

export const normalizeTheme = (value) => THEMES.some((theme) => theme.id === value) ? value : DEFAULT_THEME;

export const applyDarkMode = (dark) => {
  const enabled = Boolean(dark);
  document.documentElement.dataset.qlfColorMode = enabled ? 'dark' : 'light';
  document.documentElement.style.colorScheme = enabled ? 'dark' : 'light';
  document.body?.classList.toggle('dark-mode', enabled);
  localStorage.setItem('qlf-dark-mode', String(enabled));
  return enabled;
};

export const applyTheme = (value) => {
  const theme = normalizeTheme(value);
  document.documentElement.dataset.qlfTheme = theme;
  applyDarkMode(localStorage.getItem('qlf-dark-mode') === 'true');
  localStorage.setItem('qlf-theme', theme);
  return theme;
};
